import Hero from "@/components/Hero";
import BrandMarquee from "@/components/BrandMarquee";
import QcPartners from "@/components/QcPartners";
import Promise from "@/components/Promise";
import ServicePillars from "@/components/ServicePillars";
import DarkStoreOps from "@/components/DarkStoreOps";
import SupplyChainFlow from "@/components/SupplyChainFlow";
import OperatingFramework from "@/components/OperatingFramework";
import MarketplaceManagement from "@/components/MarketplaceManagement";
import WhyOneHill from "@/components/WhyOneHill";
import CtaBanner from "@/components/CtaBanner";

export default function Home() {
  return (
    <div data-testid="page-home">
      <Hero />
      <BrandMarquee />
      <QcPartners />
      <Promise />
      <ServicePillars />
      <DarkStoreOps />
      <SupplyChainFlow />
      <OperatingFramework />
      <MarketplaceManagement />
      <WhyOneHill />
      <CtaBanner />
    </div>
  );
}
